import { motion } from "framer-motion";
import { ShoppingBasket } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";

export const Navbar = () => {
  const { count, setIsOpen } = useCart();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="sticky top-0 z-50 border-b border-parchborder bg-parchment/85 backdrop-blur-md"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
          data-testid="nav-logo"
        >
          <img
            src="/logo.png"
            alt="Pickle Me OK! logo"
            className="w-10 h-10 rounded-full object-cover ring-2 ring-dill/15 group-hover:ring-terra transition-shadow duration-300"
          />
          <span className="font-serif font-black text-lg tracking-tight text-dill">
            Pickle Me <span className="text-terra">OK!</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-ink/70">
          <button onClick={() => scrollTo("shop")} className="hover:text-terra transition-colors" data-testid="nav-shop-link">
            The Shop
          </button>
          <button onClick={() => scrollTo("reviews")} className="hover:text-terra transition-colors" data-testid="nav-reviews-link">
            Reviews
          </button>
          <button onClick={() => scrollTo("story")} className="hover:text-terra transition-colors" data-testid="nav-story-link">
            Our Roots
          </button>
          <button onClick={() => scrollTo("find-us")} className="hover:text-terra transition-colors" data-testid="nav-findus-link">
            Find Us
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/admin"
            className="hidden sm:block font-mono text-[11px] uppercase tracking-[0.2em] text-ink/50 hover:text-terra transition-colors"
            data-testid="admin-portal-open-button"
          >
            Owner
          </Link>
          <button
            onClick={() => setIsOpen(true)}
            className="relative flex items-center gap-2 bg-dill hover:bg-terra text-parchment rounded-full pl-4 pr-5 py-2 text-sm font-semibold transition-colors duration-300"
            data-testid="cart-drawer-trigger-button"
          >
            <ShoppingBasket className="w-4 h-4" />
            <span className="hidden sm:inline">Basket</span>
            {count > 0 && (
              <span
                className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-terra text-[11px] font-bold flex items-center justify-center"
                data-testid="cart-count-badge"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
